import { Checkbox } from '@mui/material';
import { NestedCheckboxFormControlLabel, NestedCheckboxGroupWrapper } from './CommonNestedStyles';

export default function NestedSelectAllCheckbox({
    checked,
    indeterminate,
    onChange,
    label,
}: {
    checked: boolean;
    indeterminate: boolean;
    onChange: () => void;
    label: string;
}) {
    return (
        <NestedCheckboxGroupWrapper first>
            <NestedCheckboxFormControlLabel
                control={<Checkbox size="medium" checked={checked} indeterminate={indeterminate} onChange={onChange} />}
                label={label}
            />
        </NestedCheckboxGroupWrapper>
    );
}
